import { TariffFeature } from '@/api/enums/TariffFeature.ts';
import { StandardResponseItem, TariffResponseItem } from '@/api/types';
import { getEnumKeyByValue } from '@/utils';

import cn from './styles.module.sass';

interface ITariffOptionsListProps {
    options?: TariffResponseItem['options'];
    tariffOptions?: StandardResponseItem[];
}

export const TariffOptionsList = ({ options, tariffOptions }: ITariffOptionsListProps) => {
    return (
        <div className={cn.tariffOptions}>
            {options?.map(item => {
                const tariffOption = tariffOptions?.find(option => option.id === item);
                const optionIconName = getEnumKeyByValue(TariffFeature, item)?.toLowerCase();
                return (
                    <div key={item} className={cn.tariffOptionsItem}>
                        <img src={`/images/icons/features/${optionIconName}.svg`} alt="" />
                        {tariffOption?.name}
                    </div>
                );
            })}
        </div>
    );
};
